import { observable, action, computed } from 'mobx'
import PT from 'prop-types'

const mkStore = (
  params,
  props,
  { users }
) => {
  const store = observable({
    email: computed(() => users.self.email),
    showEditEmail: false,
    showEditPassword: false,
    handleClickEditPassword: action(() => {
      store.showEditPassword = true
    }),
    handleClickEditEmail: action(() => {
      store.showEditEmail = true
    }),
    handleCloseDialog: action(() => {
      store.showEditPassword = false
      store.showEditEmail = false
    }),
  })

  return store
}

mkStore.contextTypes = {
  users: PT.object.isRequired,
}

export default mkStore
